import * as React from 'react';

import * as styles from './Dropdown.css';

interface IDropdownProps {
  onMouseLeave(): void;
  onMouseEnter(): void;
}

export const Dropdown: React.FC<IDropdownProps> = ({ onMouseLeave, onMouseEnter, children }) => (
  <div className={styles['container']} onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
    {children}
  </div>
);
